import axios from "axios";

declare global {
  interface Window {
    _env_?: {
      REACT_APP_API_URL?: string;
      REACT_APP_WEBSITE_URL?: string;
    };
  }
}

// Read from window._env_ first (generated at container startup from Azure
// App Service Application Settings), falling back to the build-time value
// for local dev via `react-scripts start`, where startup.sh never runs.
export let BASE_URL =
  window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

// export const baseURL =
//   process.env.NODE_ENV === "development"
//     ? "http://localhost:3000"
//     : "https://test-api.spattro.com/";

export const baseURL = BASE_URL;

// Public patient-facing website (spattro-client). Used to build shareable
// links such as consultant booking links. Trailing slash stripped.
export const WEBSITE_URL = (
  window._env_?.REACT_APP_WEBSITE_URL ||
  process.env.REACT_APP_WEBSITE_URL ||
  ""
).replace(/\/+$/, "");

// Create axios instance
export const instance = axios.create({
  baseURL: BASE_URL,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
